module.exports = __webpack_public_path__ + "media/src/images/users-128-98b1f0a6764168fc79686de38056cedb.png";